import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import CustomDialog, { CustomDialogProps } from "../../../components/Dialog/CustomDialog";
import { ProductContext } from "../../../contexts/ProductContext";
import { CompetitorAddFormType } from "../../../api/models/product/CompetitorSampleAddFormType";
import CompetitorAddForm from "./CompetitorAddForm";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      marginBottom: theme.spacing(5),
    },
  }),
);

const ProductSampleAddCompetitorDialog = (props: CustomDialogProps) => {
  const classes = useStyles(props);
  const { open, onClose } = props;

  return (
    <ProductContext.Consumer>
      {(productContext) => {
        const { updateCompetitorCompany, updateCompetitorProduct } = productContext;

        const submitForm = (values: CompetitorAddFormType) => {
          updateCompetitorCompany(values?.product?.company);
          updateCompetitorProduct(values.product);
          onClose(true);
        };

        return (
          <CustomDialog fullWidth maxWidth="sm" onClose={() => onClose(false)} open={open}>
            <h2 className={classes.header}>ADD COMPETITOR PRODUCT</h2>
            <CompetitorAddForm handleSubmit={submitForm} />
          </CustomDialog>
        );
      }}
    </ProductContext.Consumer>
  );
};

export default ProductSampleAddCompetitorDialog;
